import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { loadAppConfig } from './common/api/SafeClient';

console.log("invalidated")
// loadAppConfig never rejects; API calls must not happen before it resolves.
loadAppConfig().then(() => {
  ReactDOM.render(
    <App />,
    document.getElementById('root')
  );
});